import { render, staticRenderFns } from "./sponsors.vue?vue&type=template&id=5e0805ca&"
import script from "./sponsors.vue?vue&type=script&lang=js&"
export * from "./sponsors.vue?vue&type=script&lang=js&"
import style0 from "./sponsors.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports